import React from 'react'

type Props = {
    className?: string
}

export const ChevronLeftIcon = (props: Props) => {
    const { className = "w-5 h-5" } = props
    return (
        <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
            <path d="m15 18-6-6 6-6"/>
        </svg>
    )
}
